<template>
    <div id="list-brands-component" class="w-full h-full">
        <div class="flex items-end justify-between gap-2">
            <span v-if="isLoading"> Cargando...</span>
            <custom-simple-select
                v-else
                v-model="option"
                :label="label"
                mode="search"
                class="w-full"
                :options="selectOptions"
                :disabled="!enabled"
                @focus="onFocus"
                @change="onInput"
            />

            <app-button
                v-if="enabled"
                icon
                circle
                color="brand-purple"
                @click="reloadItems(true)"
            >
                <reload-icon class="h-5 w-5 text-white" />
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "SublineSelector",
    components: { ReloadIcon, CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => ({
                name: "",
                slug: null
            }),
            type: Object,
            require: true
        },
        label: {
            default: () => "Categoría",
            type: String,
            required: false
        },
        fill: {
            default: () => false,
            type: Boolean,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        addRoot: {
            default: () => false,
            type: Boolean,
            required: false
        },
        defaultFilters: {
            default: () => ({
                active: true
            }),
            type: Object,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "null",
        options: [],
        isLoading: true
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        selectOptions() {
            return this.options.map((item) => ({
                label: item.name,
                value: item.slug
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
        this.reloadItems(true);
    },
    methods: {
        ...mapActions("commons", ["listAllLinesAndSublines"]),
        async reloadItems(required = true) {
            this.isLoading = true;
            try {
                const options = await this.listAllLinesAndSublines({
                    required,
                    ...this.defaultFilters
                });
                this.options = this.setValidateRootOption(options);
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        onFocus() {
            this.$emit("focus");
        },
        onBlur() {
            this.$emit("blur");
        },
        onInput() {
            const aux = this.options.find((item) => this.option === item.slug);
            this.optionComplete = aux;
            if (aux) {
                this.$emit("change", aux);
            }
        },
        setInput(value) {
            const aux = this.options.find((item) => item.slug === value?.slug);
            if (!aux) {
                this.options = [value];
            }
            this.option = value.slug ?? null;
            this.isLoading = false;
        },
        setValidateRootOption(options) {
            if (this.addRoot) {
                const optionRoot = options.find((item) => item.slug === "null");
                if (!optionRoot) {
                    return [...options, { slug: "null", name: "Root" }];
                }
            }
            return options;
        }
    }
};
</script>
